import { render, staticRenderFns } from "./attention.vue?vue&type=template&id=9b37ff5c&scoped=true"
import script from "./attention.vue?vue&type=script&lang=js"
export * from "./attention.vue?vue&type=script&lang=js"
import style0 from "./attention.vue?vue&type=style&index=0&id=9b37ff5c&prod&lang=less&scoped=true"
import style1 from "./attention.vue?vue&type=style&index=1&id=9b37ff5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b37ff5c",
  null
  
)

export default component.exports